import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useDeletePublisherMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (id: number) => Api.publishers.deletePublisher(project, id),
  });
}
